import { Button, MenuItem, styled } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
export const ProfileIconButton = styled(Button)({
  background: "#FFF",
  ":hover": {
    background: "#FFF",
  },
});

export const StyledPersonIcon = styled(PersonIcon)({
  color: "#2BB9D9",
  border: "2px solid  #2BB9D9",
  borderRadius: 100,
  marginRight:4
});

export const UserName = styled("span")({
  color: "#2BB9D9",
  marginLeft: 10,
});

export const StyledLogOutMenu = styled(MenuItem)({
    width: 200,
    height: 20,
    display: "flex",
    justifyContent: "center",
});

